import { TemplateWrapper } from './Wrapper';
import { Controller } from 'react-hook-form';
import { Input } from '@design-system/components/input/input';
import { Textarea } from '@design-system/components/textarea/textarea';
import { Button } from '@design-system/components/button/button';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Duration, Exercise, RestBetween } from './Exercise';
import { EditWorkoutVM } from '../../view-models/workoutEdit.viewModel';
import { ArrayItem } from '@client/new/helpers/types';
import {
  CircuitTemplate,
  WorkoutItemTemplates,
} from '../../view-models/mappers';

type CircuitProps = { index: number; expand: boolean } & Pick<
  EditWorkoutVM,
  | 'influencerId'
  | 'dispatch'
  | 'control'
  | 'submitting'
  | 'inputHints'
  | 'readonly'
  | 'exerciseSuggestions'
> &
  Pick<ArrayItem<WorkoutItemTemplates>, 'header' | 'menuItems'> &
  CircuitTemplate;

export const Circuit = (p: CircuitProps) => (
  <div>
    <TemplateWrapper {...p}>
      <div className="bg-white w-full flex p-4 gap-6 rounded-b-xl flex-col">
        <div className="flex flex-col gap-6">
          <div className="flex gap-6 flex-col md:flex-row">
            <div className="w-full">
              <Controller
                name={`exercises.${p.index}.name`}
                control={p.control}
                render={({ field: { onChange, value }, fieldState }) => (
                  <Input
                    label="Title"
                    required
                    disabled={p.submitting || p.readonly}
                    value={value}
                    onChange={onChange}
                    error={fieldState.error?.message}
                  />
                )}
              />
              <Controller
                name={`exercises.${p.index}.description`}
                control={p.control}
                render={({ field: { onChange, value }, fieldState }) => (
                  <Textarea
                    label="Description"
                    rows={4}
                    disabled={p.submitting || p.readonly}
                    value={value}
                    onChange={onChange}
                    error={fieldState.error?.message}
                  />
                )}
              />
            </div>
            <div className="w-full flex flex-col">
              <Duration
                index={p.index}
                control={p.control}
                submitting={p.submitting}
                readonly={p.readonly}
              />
              <RestBetween
                index={p.index}
                control={p.control}
                disabled={p.readonly}
              />
            </div>
          </div>
          <div className="flex flex-col gap-6">
            {p.exercises.map((exercise, i) => (
              <Exercise
                key={exercise.value.uuid}
                {...exercise.value}
                header={exercise.header}
                menuItems={exercise.menuItems}
                influencerId={p.influencerId}
                dispatch={p.dispatch}
                index={i}
                control={p.control}
                submitting={p.submitting}
                circuitIndex={p.index}
                inputHints={p.inputHints}
                readonly={p.readonly}
                exerciseSuggestions={p.exerciseSuggestions}
                expand={p.expand}
              />
            ))}
          </div>
        </div>
        <div className="flex gap-4">
          <Button
            variant="text"
            leftIcon={faPlus}
            onClick={() => p.dispatch('addWorkoutCircuitItem', p.index)}
            className="max-w-[150px]"
            disabled={p.readonly}
          >
            Add exercise
          </Button>
          <Button
            variant="text"
            leftIcon={faPlus}
            onClick={() =>
              p.dispatch('openLibrary', {
                index: p.index,
                circuitIndex: p.index,
                type: 'short',
                action: 'add',
              })
            }
            className="max-w-[250px]"
            disabled={p.readonly}
          >
            Add from library
          </Button>
        </div>
      </div>
    </TemplateWrapper>
  </div>
);
